import { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

const AutoLogout = ({ logout }) => {
  const timerRef = useRef(null);
  const warningTimerRef = useRef(null);

  const TIMEOUT = 60 * 60 * 1000; // 1 hour inactivity timeout
  const WARNING_BEFORE_LOGOUT = 60 * 1000; // 1 minute before logout

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  const showWarning = useCallback(() => {
    console.log('⚠️ User will be logged out in 1 minute due to inactivity');
  }, []);

  const resetTimer = useCallback(() => {
    // Clear previous timers
    if (timerRef.current) clearTimeout(timerRef.current);
    if (warningTimerRef.current) clearTimeout(warningTimerRef.current);

    // Set new timers
    timerRef.current = setTimeout(handleLogout, TIMEOUT);
    warningTimerRef.current = setTimeout(showWarning, TIMEOUT - WARNING_BEFORE_LOGOUT);
  }, [handleLogout, showWarning]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];

    // Attach listeners to reset the timer on user activity
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Start initial timer
    resetTimer();

    return () => {
      // Cleanup listeners and timers
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
      if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
    };
  }, [resetTimer]);

  return null;
};

AutoLogout.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default AutoLogout;
